import PLDP from './PLDPView';

export default PLDP;
